import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type TalentBoardFiltersState = {
  topProfileFilter: boolean;
  setTopProfileFilter: (topProfileFilter: boolean) => void;
  notMarkedAsSeenFilter: boolean;
  setNotMarkedAsSeenFilter: (notMarkedAsSeenFilter: boolean) => void;
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
  addedAfterDate: Date | null;
  setAddedAfterDate: (addedAfterDate: Date | null) => void;
  resetFilters: () => void;
};

export const useTalentBoardFiltersStore = create<TalentBoardFiltersState>()(
  persist(
    (set) => ({
      topProfileFilter: false,
      setTopProfileFilter: (topProfileFilter: boolean) => set({ topProfileFilter }),
      notMarkedAsSeenFilter: false,
      setNotMarkedAsSeenFilter: (notMarkedAsSeenFilter: boolean) => set({ notMarkedAsSeenFilter }),
      searchQuery: '',
      setSearchQuery: (searchQuery: string) => set({ searchQuery }),
      addedAfterDate: null,
      setAddedAfterDate: (addedAfterDate: Date | null) => set({ addedAfterDate }),
      resetFilters: () =>
        set({
          topProfileFilter: false,
          notMarkedAsSeenFilter: false,
          searchQuery: '',
          addedAfterDate: null,
        }),
    }),
    {
      name: 'bloomays-talentboard-filters-store',
      partialize: (state) => ({
        topProfileFilter: state.topProfileFilter,
        notMarkedAsSeenFilter: state.notMarkedAsSeenFilter,
        searchQuery: state.searchQuery,
        addedAfterDate: state.addedAfterDate,
      }),
    },
  ),
);

export default useTalentBoardFiltersStore;
